import { render, staticRenderFns } from "./EmergencyTransportPatientList.vue?vue&type=template&id=1dedb348&scoped=true&lang=pug"
import script from "./EmergencyTransportPatientList.vue?vue&type=script&lang=ts"
export * from "./EmergencyTransportPatientList.vue?vue&type=script&lang=ts"
import style0 from "./EmergencyTransportPatientList.vue?vue&type=style&index=0&id=1dedb348&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dedb348",
  null
  
)

export default component.exports